module.exports = __webpack_public_path__ + "img/zu-h10xb-19_15.prt.8508584a.jpg";